import React from 'react';

export const MultiplayerSection = () => {
  const modes = [
    { players: '2', label: '1V1 BATTLES', desc: 'Pure head-to-head domino warfare. No excuses.', rotate: '-rotate-2' },
    { players: '3', label: 'FREE-FOR-ALL', desc: 'Three-way chaos — trust no one, dominate all.', rotate: 'rotate-0', featured: true },
    { players: '4', label: 'TEAM MODE', desc: 'Squad up and coordinate to conquer.', rotate: 'rotate-2' },
  ];

  return (
    <section className="relative bg-neutral-900 text-white py-24 overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-yellow-400 to-yellow-600"></div>
      <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-l from-yellow-400 to-transparent opacity-30"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="mb-16 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div>
            <div className="bg-yellow-400 text-black px-4 py-1 inline-block font-bold text-xs uppercase tracking-widest transform -skew-x-12 mb-4 shadow-[4px_4px_0px_#000]">
              👥 MULTIPLAYER
            </div>
            <h2 className="font-anton text-5xl md:text-7xl uppercase leading-none transform -rotate-1">
              PLAY <span className="text-yellow-400">YOUR</span> WAY
            </h2>
          </div>
          <p className="font-marker text-gray-400 text-xl max-w-sm transform rotate-1 border-l-4 border-yellow-400 pl-4">
            Compete with friends or challenge players worldwide. Every match is a new battle.
          </p>
        </div>

        {/* Player Mode Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {modes.map((mode, i) => (
            <div key={i} className={`relative ${mode.rotate} group`}>
              {mode.featured && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white font-bold text-xs px-4 py-1 uppercase tracking-widest whitespace-nowrap border-2 border-black z-10">
                  MOST POPULAR
                </div>
              )}
              <div className={`${mode.featured ? 'bg-yellow-400 text-black border-4 border-black shadow-[8px_8px_0px_#fff]' : 'bg-black border-2 border-gray-700 text-white'} p-8 hover:-translate-y-2 transition-all duration-300`}>
                <div className={`font-anton text-8xl leading-none mb-2 ${mode.featured ? 'text-black' : 'text-yellow-400'}`}>{mode.players}</div>
                <div className={`font-bold text-xs uppercase tracking-widest mb-3 ${mode.featured ? 'text-gray-800' : 'text-gray-500'}`}>PLAYERS</div>
                <h3 className="font-anton text-2xl mb-3">{mode.label}</h3>
                <p className={`font-sans text-sm leading-relaxed ${mode.featured ? 'text-gray-800' : 'text-gray-400'}`}>{mode.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Social Features */}
        <div className="bg-black border-2 border-gray-700 p-8 transform -skew-x-1 border-l-8 border-l-yellow-400">
          <div className="transform skew-x-1">
            <div className="font-anton text-sm uppercase tracking-widest text-yellow-400 mb-6">💬 SOCIAL FEATURES</div>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-yellow-400 flex items-center justify-center flex-shrink-0">
                  <iconify-icon icon="solar:chat-round-line-linear" width="28" className="text-black"></iconify-icon>
                </div>
                <div>
                  <h4 className="font-anton text-xl mb-1">REAL-TIME CHAT</h4>
                  <p className="font-sans text-gray-400 text-sm leading-relaxed">Stay connected with opponents during matches. Talk strategy or trash — we don't judge.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-yellow-400 flex items-center justify-center flex-shrink-0">
                  <iconify-icon icon="solar:emoji-funny-circle-linear" width="28" color="#000"></iconify-icon>
                </div>
                <div>
                  <h4 className="font-anton text-xl mb-1">EMOJI REACTIONS 😎🔥💥</h4>
                  <p className="font-sans text-gray-400 text-sm leading-relaxed">Express yourself mid-game with animated reactions that keep energy levels high.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
